<div class="meeting-signature-container">
  <h2>{{ title }}</h2>

  <div class="signature-status">
    <p>簽名狀態: <strong>{{ signedCount }}/{{ totalCount }}</strong></p>
  </div>

  <!-- 新增參與者表單 -->
  <div class="add-participant-form">
    <h3>新增參與者</h3>
    <div class="form-group">
      <label for="participantName">姓名: <span class="required">*</span></label>
      <input
        type="text"
        id="participantName"
        [(ngModel)]="newParticipant.name"
        required
        placeholder="請輸入參與者姓名"
      />
    </div>

    <div class="form-group">
      <label for="participantTitle">職稱:</label>
      <input
        type="text"
        id="participantTitle"
        [(ngModel)]="newParticipant.title"
        placeholder="請輸入職稱"
      />
    </div>

    <div class="form-group">
      <label for="participantDepartment">部門:</label>
      <input
        type="text"
        id="participantDepartment"
        [(ngModel)]="newParticipant.department"
        placeholder="請輸入部門"
      />
    </div>

    <button
      type="button"
      class="btn-add"
      (click)="addParticipant()"
    >
      新增參與者
    </button>
  </div>

  <!-- 參與者簽名列表 -->
  <div class="participants-list">
    <div *ngFor="let participant of participants" class="participant-item">
      <div class="participant-info">
        <h4>{{ participant.name }}</h4>
        <p *ngIf="participant.title || participant.department">
          <span *ngIf="participant.title">{{ participant.title }}</span>
          <span *ngIf="participant.department"> [{{ participant.department }}]</span>
        </p>
        <p *ngIf="participant.signedAt">
          簽名時間: {{ participant.signedAt | date:'yyyy-MM-dd HH:mm:ss' }}
        </p>
      </div>

      <div class="signature-area">
        <app-form-signature
          [id]="'signature_' + participant.id"
          [name]="'participant_signature_' + participant.id"
          [label]="'簽名'"
          [width]="300"
          [height]="120"
          [completeButtonText]="'完成簽名'"
          [clearButtonText]="'重新簽名'"
          (ngModelChange)="onSignatureChange($event, participant.id)"
          [ngModel]="participant.signature"
        ></app-form-signature>
      </div>

      <button
        type="button"
        class="btn-remove"
        (click)="removeParticipant(participant.id)"
        title="移除此參與者"
      >
        ✕
      </button>
    </div>

    <div *ngIf="participants.length === 0" class="no-participants">
      <p>尚未添加任何參與者，請使用上方表單新增參與者。</p>
    </div>
  </div>
</div>
